import React from 'react';
import GenericChat from './GenericChat';
import { useHealthOpsChat } from '../../hooks/useHealthOpsChat';

const HealthOpsChat = () => {
  const healthOpsConfig = {
    title: "HealthOps Agent",
    subtitle: "AWS Health Events Specialist",
    avatar: "🤖",
    placeholder: "Ask HealthOps about AWS Health Events or critical alerts...",
    gradientFrom: "#831f82",
    gradientTo: "#2e0059"
  };

  return (
    <GenericChat 
      chatHook={useHealthOpsChat}
      config={healthOpsConfig}
    />
  );
};

export default HealthOpsChat;